var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 87.78 87.78"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h87.78v87.78H0Z",
  "data-name": "Path 19095"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m54.862 10.972 8.41 8.412-10.57 10.5 5.196 5.188 10.5-10.57 8.412 8.412V10.972Zm-43.89 21.945 8.412-8.412 10.5 10.57 5.188-5.194-10.57-10.5 8.415-8.409H10.972Zm21.945 43.89-8.412-8.412 10.57-10.5-5.194-5.194-10.497 10.571-8.412-8.41v21.945Zm43.89-21.945-8.412 8.41-10.5-10.57-5.194 5.194 10.57 10.5-8.409 8.411h21.945Z",
  "data-name": "Path 19096"
})));
export default SvgExpand;